import { 
  Phone, 
  PresentationChart, 
  PaintBrush, 
  RocketLaunch 
} from 'phosphor-react';

interface FeatureTilesProps {
  theme: any;
  radius: number;
  iconWeight: string;
}

export default function FeatureTiles({ theme, radius }: FeatureTilesProps) {
  const features = [
    {
      icon: <Phone size={24} weight="duotone" />,
      title: "CONNECT",
      description: "Share your business goals and Chicago audience"
    },
    {
      icon: <PresentationChart size={24} weight="duotone" />,
      title: "DISCOVER",
      description: "Get instant multimedia campaign recommendations"
    },
    {
      icon: <PaintBrush size={24} weight="duotone" />,
      title: "CREATE",
      description: "Our team designs your custom advertising mix"
    },
    {
      icon: <RocketLaunch size={24} weight="duotone" />,
      title: "CONVERT",
      description: "Launch and track your Chicago success story"
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
      {features.map((feature, index) => (
        <div
          key={index}
          className="p-6 transition-all duration-200 hover:shadow-lg"
          style={{
            backgroundColor: theme.card,
            border: `1px solid ${theme.border}`,
            borderRadius: radius
          }}
        >
          <div className="flex items-center gap-4 mb-3">
            <div 
              className="p-2 rounded-lg"
              style={{
                backgroundColor: theme.surface === 'dark' ? 'rgba(255, 255, 255, 0.1)' : '#f3f4f6',
                color: '#FFFFFF'
              }}
            >
              {feature.icon}
            </div>
            <h4 className="text-lg font-semibold font-primary" style={{ color: theme.text }}>
              {feature.title}
            </h4>
          </div>
          <p className="text-sm font-primary" style={{ color: theme.mutedText }}>
            {feature.description}
          </p>
        </div>
      ))}
    </div>
  );
}
